import { Expose, Type } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { SnUser } from '../user';
import { FmRecordings } from './recordings';
import { FmRoom } from './room';

export class FmParticipant extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public createdTimestamp: string;

  @Expose()
  public updatedTimestamp: string;

  @Expose()
  @Type(() => FmRoom)
  public room: FmRoom;

  @Expose()
  @Type(() => SnUser)
  public user: SnUser;

  @Expose()
  public name: string;

  @Expose()
  public meetingToken: string;

  @Expose()
  public status: string;

  @Expose()
  public friendlyName: string;

  @Expose()
  public isOwner: boolean;

  @Expose()
  public isExternal: boolean;

  @Expose()
  public isFususUser: boolean;

  @Expose()
  public duration: number;

  @Expose()
  public sid: string;

  @Expose()
  public hasAdminPrivileges: boolean;

  @Expose()
  public isAdmin: boolean;

  @Expose()
  public isAudioTrackAllowed: boolean;

  @Expose()
  public isDataTrackAllowed: boolean;

  @Expose()
  public isVideoTrackAllowed: boolean;

  @Expose()
  public publicToken: string;

  @Expose()
  public subscribeRules: any;

  @Expose()
  public recordings: FmRecordings[];

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}
